module.exports = __webpack_public_path__ + "res/24-img_top_center.ef5e3f460b2798a8bf210329782a31ab.png";